/**
 * Created by Reda on 21.10.26
 */

const HungryGamesExchangeTutorial = function () {
    return new TutorialScenario(HungryGamesExchangeTutorial.NAME, {
        listSteps: HungryGamesExchangeTutorial.listSteps,
        isAvailable: () => {
            const mission = cleverapps.missionManager.findRunningMission(Mission.TYPE_HUNGRY_GAMES);
            if (
                !mission
                || mission.logic.state !== HungryGamesLogic.STATES.ACTIVE
                || mission.result !== 0
                || (cleverapps.missionManager.getLastRemoved(Mission.TYPE_HUNGRY_GAMES) && cleverapps.forces.isShown(Forces.HUNGRY_GAMES)
                || cleverapps.abExperiments.getGroup(ABExperiments.Tests.hungryGamesBalance) !== "A"
                )
            ) {
                return false;
            }

            const hungryGamesCustomer = HungryGamesCustomer.findCustomer();
            return Boolean(hungryGamesCustomer && hungryGamesCustomer.getCustomer().isEnoughIngredientsForRecipe() && Map2d.currentMap.customers.isCustomerSelected(hungryGamesCustomer.getCustomer()));
        }
    });
};

HungryGamesExchangeTutorial.listSteps = function () {
    return [
        HungryGamesExchangeTutorial.createClickExchangeStep()
    ];
};

HungryGamesExchangeTutorial.createClickExchangeStep = function () {
    return new TutorialStep({
        onCheckConditions: function (options) {
            if (options.unit && !cleverapps.intersect([{ code: "hungry", stage: 0 }], options.unit, Unit.GetKey).length) {
                return false;
            }
            return true;
        },

        onStart: function () {
            this.forceTimeout = cleverapps.timeouts.setTimeout(() => {
                const unit = Map2d.currentMap.listAvailableUnits({ code: "hungry", stage: 0 })[0];
                const unitView = unit && unit.onGetView();
                const additionalView = unitView && unitView.getAdditionalView("extended_ingredients");
                const button = additionalView && additionalView.view.button;

                if (!button) {
                    this.finish();
                    return;
                }

                this.force = cleverapps.forces.create(button, {
                    text: "HungryGamesExchangeTutorial.clickExchange",
                    finger: true
                }, {
                    importantNodes: [additionalView.view]
                });

                this.button = button;
                this.originalOnClicked = button.settings.onClicked;
                button.settings.onClicked = () => {
                    this.originalOnClicked();
                    this.finish();
                };
            }, 600);
        },

        onFinish: function () {
            if (this.forceTimeout) {
                cleverapps.timeouts.clearTimeout(this.forceTimeout);
                delete this.forceTimeout;
            }
            if (this.button && this.originalOnClicked) {
                this.button.settings.onClicked = this.originalOnClicked;
            }
            if (this.force) {
                this.force.hideForceHints();
            }
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

HungryGamesExchangeTutorial.NAME = "hungry_games_exchange_tutorial";

const HungryGamesSourceTutorial = function () {
    return new TutorialScenario(HungryGamesSourceTutorial.NAME, {
        listSteps: HungryGamesSourceTutorial.listSteps,
        manual: true,
        isAvailable: () => Map2d.currentMap.listAvailableUnits({ type: "source" }).length > 0 && cleverapps.abExperiments.getGroup(ABExperiments.Tests.hungryGamesBalance) === "A"
    });
};

HungryGamesSourceTutorial.listSteps = function () {
    return [
        HungryGamesSourceTutorial.createClickHelpStep()
    ];
};

HungryGamesSourceTutorial.createClickHelpStep = function () {
    return new TutorialStep({
        onCheckConditions: function (options) {
            if (options.unit && !cleverapps.intersect([{ code: "hungry", stage: 0 }], options.unit, Unit.GetKey).length) {
                return false;
            }
            return true;
        },

        onStart: function () {
            this.forceTimeout = cleverapps.timeouts.setTimeout(() => {
                const unit = Map2d.currentMap.listAvailableUnits({ code: "hungry", stage: 0 })[0];
                const unitView = unit && unit.onGetView();
                const additionalView = unitView && (unitView.getAdditionalView("extended_ingredients") || unitView.getAdditionalView("ingredients"));
                const helpButton = additionalView && additionalView.view.customerIngredientViews && additionalView.view.customerIngredientViews[0] && additionalView.view.customerIngredientViews[0].help;

                if (!helpButton) {
                    this.finish();
                    return;
                }

                this.force = cleverapps.forces.create(helpButton, {
                    finger: true,
                    text: "HungryGamesSourceTutorial.clickUnit"
                }, {
                    importantNodes: [additionalView.view]
                });

                cleverapps.tutorial.on("ingredientHelpClick", () => {
                    this.finish();
                    helpButton.clickPointerHandler.handleClick();
                }, this);
            }, 600);
        },

        onFinish: function () {
            if (this.forceTimeout) {
                cleverapps.timeouts.clearTimeout(this.forceTimeout);
                delete this.forceTimeout;
            }
            if (this.force) {
                this.force.hideForceHints();
            }
            Map2dLocation.currentLocation.counter.trigger();
        }
    });
};

HungryGamesSourceTutorial.NAME = "hungry_games_source_tutorial";
